<script>
/**
 * 新版首页（VANCHEEN / Vancheen B2B 官网首页）
 * ---------------------------------------------------------------
 * 自桌面独立项目 vancheen-b2b（Vue 3 + Vite）整体移植为 Vue 2 版本，
 * 成为 vancheen-pc 的默认首页（路由 `/`）；旧版 B2B 首页移至 `/old`。
 *
 * 页面结构：Hero 轮播 → 数字条 → 两条业务线 → 汽车配件精选 →
 *           建材精选 → Why VANCHEEN（10 个教训横滑）→ 工厂速览 → CTA
 *
 * 头部保留旧版右上角 4 个功能（切换电商平台 / 管理员 / 供应商 / 语言），
 * 并新增「旧版首页」切换入口（见 NhHeader）。
 */
import NhShell from './components/NhShell.vue'
import NhHeroCarousel from './components/NhHeroCarousel.vue'
import NhStatsStrip from './components/NhStatsStrip.vue'
import NhSectionHead from './components/NhSectionHead.vue'
import NhPillarCard from './components/NhPillarCard.vue'
import NhProductCard from './components/NhProductCard.vue'
import NhLessonCard from './components/NhLessonCard.vue'
import NhCtaBand from './components/NhCtaBand.vue'
import NhCtaButton from './components/NhCtaButton.vue'
import { getSite } from './nh-site-data'
import { t, setPageTitle } from './nh-i18n'

export default {
  name: 'homeNew',
  components: {
    NhShell,
    NhHeroCarousel,
    NhStatsStrip,
    NhSectionHead,
    NhPillarCard,
    NhProductCard,
    NhLessonCard,
    NhCtaBand,
    NhCtaButton
  },
  computed: {
    HERO_SLIDES() {
      return getSite('HERO_SLIDES')
    },
    PILLARS() {
      return getSite('PILLARS')
    },
    FEATURED_AUTO() {
      return getSite('FEATURED_AUTO')
    },
    FEATURED_BUILDING() {
      return getSite('FEATURED_BUILDING')
    },
    LESSONS() {
      return getSite('LESSONS')
    },
    CTA_HOME() {
      const cta = getSite('CTA')
      return cta ? cta.home : { title: '', desc: '', actions: [] }
    }
  },
  mounted() {
    setPageTitle('home')
  },
  methods: {
    t
  }
}
</script>

<template>
  <NhShell>
    <!-- ===== HERO 轮播 ===== -->
    <NhHeroCarousel :slides="HERO_SLIDES" />

    <!-- ===== 数字统计 ===== -->
    <NhStatsStrip />

    <!-- ===== 两条业务线 ===== -->
    <section class="section">
      <div class="container">
        <NhSectionHead
          :kicker="t('home.pillarsKicker')"
          :title="t('home.pillarsTitle')"
          :desc="t('home.pillarsDesc')"
        />
        <div class="pillars-grid">
          <NhPillarCard
            v-for="(pillar, i) in PILLARS"
            :key="pillar.key"
            :pillar="pillar"
            :delay="i || undefined"
          />
        </div>
      </div>
    </section>

    <!-- ===== 汽车配件精选 ===== -->
    <section class="section bg-gray">
      <div class="container">
        <NhSectionHead
          :kicker="t('home.autoKicker')"
          :title="t('home.autoTitle')"
          :desc="t('home.autoDesc')"
        />
        <div class="product-grid">
          <NhProductCard
            v-for="(product, i) in FEATURED_AUTO"
            :key="product.name"
            :product="product"
            :delay="i || undefined"
          />
        </div>
        <div v-reveal class="text-center mt-40">
          <NhCtaButton :label="t('home.autoCta')" to="/products?cat=auto" variant="btn-outline" />
        </div>
      </div>
    </section>

    <!-- ===== 建材精选 ===== -->
    <section class="section">
      <div class="container">
        <NhSectionHead
          :kicker="t('home.buildingKicker')"
          :title="t('home.buildingTitle')"
          :desc="t('home.buildingDesc')"
        />
        <div class="product-grid">
          <NhProductCard
            v-for="(product, i) in FEATURED_BUILDING"
            :key="product.name"
            :product="product"
            :delay="i || undefined"
          />
        </div>
        <div v-reveal class="text-center mt-40">
          <NhCtaButton :label="t('home.buildingCta')" to="/products?cat=building" variant="btn-outline" />
        </div>
      </div>
    </section>

    <!-- ===== Why VANCHEEN：10 个教训（横向滚动卡片） ===== -->
    <section class="section bg-gray">
      <div class="container">
        <NhSectionHead
          :kicker="t('home.lessonsKicker')"
          :title="t('home.lessonsTitle')"
        />
        <div class="section-content">
          <NhLessonCard
            v-for="(lesson, i) in LESSONS"
            :key="i"
            :lesson="lesson"
            :delay="i"
          />
        </div>
      </div>
    </section>

    <!-- ===== CTA ===== -->
    <NhCtaBand
      :title="CTA_HOME.title"
      :desc="CTA_HOME.desc"
      :actions="CTA_HOME.actions"
      reveal
    />
  </NhShell>
</template>
